let selectedDropboxCount = 0;
let dropboxSyncInProgress = false;

// Sync images from AWS to Dropbox
const syncToDropbox = (button) => {
  let files = [],
    products = [];

  // Check if user has any preferences selected (only for Collections)
  if (button === "Collections") {
    const hasAnyPreferences =
      customerData.motions === "true" ||
      customerData.stils === "true" ||
      customerData.transparent_tex_layers === "true" ||
      customerData.photoshop_files === "true" ||
      customerData.print_files === "true" ||
      customerData.countowns === "true";

    if (!hasAnyPreferences && !document.body.classList.contains("display-dropbox-checkboxes")) {
      showErrorPopup(
        "You need to select at least one content type in your Dropbox preferences before syncing to Dropbox. Please go to your account settings and select at least one content type.",
        "/account?tab=dropbox",
        "Dropbox Preferences"
      );
      return;
    }
  }

  // Check if product is a collection
  if (button === "Collections") {
    if (document.body.classList.contains("display-dropbox-checkboxes")) {
      // Loop through all products and add them to the files array
      products = document.querySelectorAll(".product-item");
      products.forEach((product) => {
        if (product.querySelector('input[type="checkbox"]:checked')) {
          files.push(singleProductLink(product.querySelector(".dropbox-icon-product")));
        }
      });
    } else {
      // Loop through all products and add them to the files array
      if (customerData.motions && customerData.motions === "true") {
        products = products.concat(...document.querySelectorAll('.product-item[data-type="Motions"] .dropbox-icon-product'));
      }
      if (customerData.stils && customerData.stils === "true") {
        products = products.concat(...document.querySelectorAll('.product-item[data-type="Stills"] .dropbox-icon-product'));
      }
      if (customerData.transparent_tex_layers && customerData.transparent_tex_layers === "true") {
        products = products.concat(
          ...document.querySelectorAll('.product-item[data-type="Transparent Text Layers"] .dropbox-icon-product')
        );
      }
      if (customerData.photoshop_files && customerData.photoshop_files === "true") {
        products = products.concat(...document.querySelectorAll('.product-item[data-type="Pro Designer Resources"] .dropbox-icon-product'));
      }
      if (customerData.print_files && customerData.print_files === "true") {
        products = products.concat(...document.querySelectorAll('.product-item[data-type="Printables"] .dropbox-icon-product'));
      }
      if (customerData.social_media && customerData.social_media === "true") {
        products = products.concat(...document.querySelectorAll('.product-item[data-type*="Social Media"] .dropbox-icon-product'));
      }
      if (customerData.countowns && customerData.countowns === "true") {
        products = products.concat(...document.querySelectorAll('.product-item[data-type="Countdowns"] .dropbox-icon-product'));
      }
      // Loop through all products and add them to the files array
      products.forEach((product) => {
        files.push(singleProductLink(product));
      });
    }
  } else {
    files.push(singleProductLink(button));
  }

  if (files.length > 100) {
    showErrorPopup(
      "We cannot select more than 100 items at a time. Please select the items you want to sync to dropbox from the products listed below and try again."
    );
    document.body.classList.add("display-dropbox-checkboxes");
  } else {
    finalSyncDropbox(files);
  }
};
// Generate the download link for a single product
const singleProductLink = (button) => {
  const file = { url: "", filename: "" };
  const type = button.getAttribute("data-type");
  const title = button.getAttribute("data-title");
  const downloadTitle = title.toLowerCase().replace(/\s+/g, "-");

  window.productPackArray = productPackArray;
  const productsArray = window.collectionProducts || window.productPackArray || [];

  // Find the matching product from the collection array
  const matchingProduct = productsArray.find((product) => {
    const normalizedProductType = product.productType?.toLowerCase();
    const normalizedType = type?.toLowerCase();
    return product.title === title && normalizedProductType === normalizedType;
  });

  if (!matchingProduct) {
    console.warn(`No matching product found for title: ${title} and type: ${type}`);
    return file;
  }

  // Parse the AWS export data
  const awsExportData = JSON.parse(matchingProduct.awsLinkExport?.value || '{"aws_link":[]}');

  if (!awsExportData.aws_link || awsExportData.aws_link.length === 0) {
    console.warn("No AWS links available for this product");
    return file;
  }

  // Determine the appropriate variant based on user preferences and product type
  let selectedLink;
  const isMotionType =
    type && (type.toLowerCase() === "motions" || type.toLowerCase() === "mini movies" || type.toLowerCase() === "countdowns");

  if (isMotionType) {
    // For motion products, use motion preferences
    const resolution = (window.motionResolution || "HD").toLowerCase();
    const preferredFormat = (window.motionFormat || "mp4").toLowerCase();
    const size = window.motionSize || "SW";

    // Get available formats from AWS data
    const availableFormats = new Set();
    awsExportData.aws_link.forEach((link) => {
      if (link.variant && link.variant !== "preview_link") {
        const parts = link.variant.split("_");
        if (parts[0]) availableFormats.add(parts[0]);
      }
    });

    // Check if preferred format is available
    const formatArray = Array.from(availableFormats);
    const hasPreferredFormat = formatArray.some((fmt) => fmt.toLowerCase() === preferredFormat);

    if (!hasPreferredFormat) {
      // Don't fallback - let it fail and show error
      selectedLink = null;
    } else {
      // Construct the variant key with preferred format
      const variantKey = `${preferredFormat}_${resolution}${size === "TW" ? "_tw" : ""}`;

      // Find the matching AWS link
      selectedLink = awsExportData.aws_link.find((link) => link.variant.toLowerCase() === variantKey.toLowerCase());
    }
  } else {
    // For still products, use still preferences
    const resolution = (window.stillResolution || "HD").toLowerCase();
    const size = window.stillSize || "SW";

    // Get available formats from AWS data for stills
    const availableFormats = new Set();
    awsExportData.aws_link.forEach((link) => {
      if (link.variant && link.variant !== "preview_link") {
        const parts = link.variant.split("_");
        if (parts[0]) availableFormats.add(parts[0]);
      }
    });

    // Check if preferred format is available for stills
    const formatArray = Array.from(availableFormats);
    // For stills, prefer jpg, then png
    let selectedFormat = null;
    if (formatArray.includes("jpg")) {
      selectedFormat = "jpg";
    } else if (formatArray.includes("png")) {
      selectedFormat = "png";
    } else if (formatArray.includes("zip")) {
      selectedFormat = "zip";
    }

    console.log("Available selectedFormat:", selectedFormat);

    if (!selectedFormat) {
      // No preferred format available - let it fail and show error
      selectedLink = null;
    } else if (selectedFormat === "zip") {
      selectedLink = awsExportData.aws_link.find((link) => link.variant.toLowerCase() === "zip");
    } else {
      // Construct the variant key for stills
      const variantKey = `${selectedFormat}_${resolution}${size === "TW" ? "_tw" : ""}`;
      console.log("Variant Key:", variantKey);

      // Find the matching AWS link
      selectedLink = awsExportData.aws_link.find((link) => link.variant.toLowerCase() === variantKey.toLowerCase());

      if (!selectedLink) {
        selectedLink = awsExportData.aws_link.find((link) => link.variant.toLowerCase().startsWith(selectedFormat));
      }
    }
  }

  console.log("Selected Link:", selectedLink);
  // Check if preferred format is available, if not show error
  if (!selectedLink) {
    // Get the preferred format to show in error message
    let errorMessage;
    if (isMotionType) {
      const preferredFormat = (window.motionFormat || "mp4").toUpperCase();
      errorMessage = `You have selected ${preferredFormat} format but this collection doesn't have ${preferredFormat}. Please change your format preferences in your account settings.`;
    } else {
      errorMessage = `This collection doesn't have JPG or PNG formats available. Please check the available formats for this collection.`;
    }

    showErrorPopup(errorMessage);
    return { url: "", filename: "" }; // Return empty file object to prevent sync
  }

  // Set the file URL and filename
  file.url = selectedLink.aws_link.replace(/\s+/g, "%20");

  // Determine the format from the URL
  const format = selectedLink.aws_link.split(".").pop();

  // Extract resolution and size from the variant to include in filename
  const variantParts = selectedLink.variant.split("_");
  const selectedFormat = variantParts[0] || "";
  const selectedResolution = variantParts[1] || "";
  const selectedSize = variantParts[2] || "";

  // Build filename with resolution and size info
  // let filename = downloadTitle;
  // if (selectedResolution) {
  //   filename += `-${selectedResolution}`;
  // }
  // if (selectedSize === "tw") {
  //   filename += "-tw";
  // }
  // filename += `.${format}`;

  // Create directory structure based on collection name and product type
  const collectionElement = document.querySelector('section[product-type="Collections"] .product__title h1');
  const collectionName = collectionElement ? collectionElement.textContent.toLowerCase().replace(/\s+/g, "-") : "General";
  const productTypeName = type ? type.toLowerCase().replace(/\s+/g, "-") : "general";
  file.name = `${downloadTitle}`.replace(/\s+/g, "-");
  return file;
};

// Display progress bar
const updateProgressBar = (progress) => {
  document.querySelector("body").classList.add("dropbox-show-progress-bar");
  const progressBar = document.querySelector("#progress-container #progress-bar .progress");
  setTimeout(() => {
    if (progressBar.style.width === "" || progressBar.style.width === "0%") {
      progressBar.style.width = `30%`;
    } else if (progress > 0.3) {
      progressBar.style.width = `${progress * 100}%`;
    }
  }, 500);
};

// Function to handle checkbox change
const handleCheckboxChange = (event) => {
  if (event.target.checked) {
    selectedCount++;
  } else {
    selectedCount--;
  }

  // Display a popup if 100 or more items are selected
  if (selectedCount >= 100) {
    showErrorPopup("You have selected 100 items. You cannot select more.");
  }
};

const finalSyncDropbox = (files) => {
  // Filter out any files with empty URLs (from format error cases)
  const validFiles = files.filter((file) => file.url && file.url.trim() !== "");

  // If no valid files after filtering, don't proceed
  if (validFiles.length === 0) {
    return;
  }

  // Prevent starting a new sync if one is already running
  if (dropboxSyncInProgress) {
    showErrorPopup("Hold on—your Dropbox is still syncing! Please wait for it to finish, then try again.");
    return;
  }
  dropboxSyncInProgress = true;

  // Dropbox options
  let DropboxOptions = {
    files: validFiles,
    success: function () {
      setTimeout(() => {
        document.querySelector("body").classList.remove("dropbox-show-progress-bar");
        dropboxSyncInProgress = false; // Release the lock
      }, 1000);
    },
    progress: function (progress) {
      console.log("progress", progress);
      updateProgressBar(progress);
    },
    cancel: function () {
      dropboxSyncInProgress = false; // Release the lock
    },
    error: function (errorMessage) {
      showErrorPopup("There was an error uploading to dropbox. Please try again.");
      dropboxSyncInProgress = false; // Release the lock
    },
  };
  Dropbox.save(DropboxOptions);
};

async function fetchAndLogParentProduct() {
  try {
    // Pass the product data to the Liquid template
    document.getElementById("product-title").innerText = "Included in this Collection: ";
    document.getElementById("product-link").href = `/products/${productPackArray[0].handle}`;
    document.getElementById("product-image").src = productPackArray[0].images.edges[0].node.src;
  } catch (error) {
    console.error("Error fetching parent product:", error);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Display part of a collection
  if (document.getElementById("part-of-collection")) {
    // Call the function
    fetchAndLogParentProduct();
  }
});

const clickDropboxSingleWithType = async (product) => {
  console.log("clickDropboxSingle called for product:", product);

  // Show loading spinner
  showDropboxIconLoadingSpinner(product);

  const data = singleProductLink(product);

  console.log("Generated data for Dropbox sync:", data);
  try {
    // Step 1: Check if user is authenticated
    const isAuthed = await window.checkDropboxAuth(window.customerId);
    console.log("Dropbox auth status:", isAuthed);

    if (!isAuthed) {
      // Step 2: Trigger OAuth flow
      window.triggerOauth(window.customerId);

      // Listen for auth completion
      window.addEventListener("message", async (event) => {
        if (event.origin !== "https://apps.shiftworship.com") {
          console.warn("Received message from unknown origin:", event.origin);
          return;
        }
        if (event.data && event.data.type === "dropbox-auth-success") {
          console.log("Dropbox authentication complete. Starting sync...");
          await performDropboxSyncWithType(data, product);
        }
      });
    } else {
      // User is already authenticated, start sync immediately
      await performDropboxSyncWithType(data, product);
    }
  } catch (error) {
    console.error("Error in clickDropboxSingle:", error);
    hideDropboxIconLoadingSpinner(product);
    showErrorPopup("An error occurred while syncing to Dropbox.");
  }
};

// New function to handle the actual sync request
async function performDropboxSyncWithType(product, buttonElement) {
  try {
    // Get the download link for the selected product
    const downloadLink = product.url;
    if (!downloadLink) {
      updateDropboxSyncStatusWithType("Failed", "", 0, "error");
      autoHideDropboxSyncStatusWithType();
      if (buttonElement) hideDropboxIconLoadingSpinner(buttonElement);
      return;
    }

    // Extract filename from URL
    const fileName = downloadLink.split("/").pop();

    // Get product/collection name for the sync request
    const productName = product.name || "Untitled Product";

    const collectionName = document.querySelector("div.product__title > h1").textContent || productPackArray?.[0]?.title?.toLowerCase();

    let finalName = collectionName || productName;
    // lowercase and replace the dashes with spaces
    finalName = finalName
      .toLowerCase()
      .replace(/-/g, " ")
      .replace(/[^\w\s]/g, "");

    const syncPayload = {
      shopifyUserId: window.customerId,
      syncScope: "custom",
      name: finalName,
      files: [
        {
          url: downloadLink,
          name: fileName,
        },
      ],
      userPreferences: {
        dropboxPreferences: [window.productData?.productType || "general"],
        mediaPreferences: getMediaPreferences(),
      },
    };

    console.log("Triggering Dropbox sync with payload:", syncPayload);

    const URL = "https://apps.shiftworship.com";
    // Make the sync request
    const response = await fetch(`${URL}/api/dropbox/sync`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(syncPayload),
    });

    if (!response.ok) {
      throw new Error(`Sync request failed: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();
    console.log("Dropbox sync initiated. Job ID:", result.jobId);

    updateDropboxSyncStatusWithType("Processing...", "", 75);

    // Start polling for sync status
    await pollSyncStatusWithType(result.jobId, buttonElement);

    // showErrorPopup(`Dropbox sync started! Your file will be available in Dropbox shortly.`);
  } catch (error) {
    console.error("Error performing Dropbox sync:", error);
    updateDropboxSyncStatusWithType("Error", "", 0, "error");
    autoHideDropboxSyncStatusWithType();
    if (buttonElement) hideDropboxIconLoadingSpinner(buttonElement);
  }
}

// Helper function to get media preferences from current selections
function getMediaPreferences() {
  const selectedResolutionElement = document.querySelector('input[name="resolution"]:checked');
  const selectedFormatElement = document.querySelector('input[name="format"]:checked');
  const selectedWidthElement = document.querySelector('input[name="width"]:checked');

  const productType = window.productData?.productType?.toLowerCase();

  // Default preferences based on product type
  let preferences = {
    videoFormat: "mp4",
    motionWidth: "sw",
    motionResolution: "hd",
    stillWidth: "sw",
    stillResolution: "hd",
  };

  // Override with user selections if available
  if (selectedFormatElement) {
    preferences.videoFormat = selectedFormatElement.value.toLowerCase();
  }

  if (selectedResolutionElement) {
    const resolution = selectedResolutionElement.value.toLowerCase();
    if (productType?.includes("motion") || productType?.includes("movie") || productType?.includes("countdown")) {
      preferences.motionResolution = resolution;
    } else {
      preferences.stillResolution = resolution;
    }
  }

  if (selectedWidthElement) {
    const width = selectedWidthElement.value.toLowerCase();
    if (productType?.includes("motion") || productType?.includes("movie") || productType?.includes("countdown")) {
      preferences.motionWidth = width;
    } else {
      preferences.stillWidth = width;
    }
  }

  return preferences;
}

// Get preview URL if available, otherwise return regular URL
function getPreviewOrRegularUrl() {
  const awsLinks = window.awsLinkExportSingle?.aws_link;

  if (!awsLinks || !Array.isArray(awsLinks) || awsLinks.length === 0) {
    return productSyncToDropboxWithSelectedValues();
  }

  // 1. If includes preview use that
  const previewLink = awsLinks.find((link) => link.variant && link.variant.includes("preview"));
  if (previewLink) {
    return previewLink.aws_link;
  }

  // 2. If has mp4_hd or mov_hd use that
  const hdLink = awsLinks.find((link) => link.variant === "mp4_hd" || link.variant === "mov_hd");
  if (hdLink) {
    return hdLink.aws_link;
  }

  // 3. If not, use the first child on awsLinkExportSingle
  if (awsLinks[0]) {
    return awsLinks[0].aws_link;
  }

  // Final fallback
  return productSyncToDropboxWithSelectedValues();
}

//Display the video player
setTimeout(() => {
  let videoLink = getPreviewOrRegularUrl();
  if (document.querySelector("video.video-player") && videoLink && videoLink.length > 0) {
    document.querySelector("video.video-player").src = videoLink;
    document.querySelector("body").classList.add("video-show");
  }
}, 500);

// New function to poll sync status
async function pollSyncStatusWithType(jobId, buttonElement) {
  const maxAttempts = 30; // Maximum number of polling attempts
  const pollInterval = 2000; // Poll every 2 seconds
  let attempts = 0;

  console.log(`Starting sync status polling for job: ${jobId}`);

  const poll = async () => {
    try {
      attempts++;

      const response = await fetch(
        `https://apps.shiftworship.com/api/dropbox/sync-status?shopifyUserId=${encodeURIComponent(
          window.customerId
        )}&jobId=${encodeURIComponent(jobId)}`
      );

      if (!response.ok) {
        throw new Error(`Status check failed: ${response.status} ${response.statusText}`);
      }

      const statusData = await response.json();
      console.log(`Sync status (attempt ${attempts}):`, statusData.status);

      switch (statusData.status) {
        case "complete":
          console.log("Dropbox sync completed successfully!");
          updateDropboxSyncStatusWithType("Complete!", "", 100, "success");
          if (buttonElement) {
            // Show checkmark first
            showDropboxIconCheckmark(buttonElement);
            // After 1 second, hide checkmark and show dropbox icon
            setTimeout(() => {
              hideDropboxIconLoadingSpinner(buttonElement);
            }, 1000);
          }
          autoHideDropboxSyncStatusWithType();
          return;

        case "failed":
          console.error("Dropbox sync failed");
          updateDropboxSyncStatusWithType("Failed", "", 0, "error");
          if (buttonElement) hideDropboxIconLoadingSpinner(buttonElement);
          autoHideDropboxSyncStatusWithType();
          return;

        case "in_progress":
          if (attempts >= maxAttempts) {
            console.warn("Sync status polling timeout reached");
            updateDropboxSyncStatusWithType("Timeout", "", 90, "error");
            if (buttonElement) hideDropboxIconLoadingSpinner(buttonElement);
            autoHideDropboxSyncStatusWithType();
            return;
          }

        case "pending":
          if (attempts >= maxAttempts) {
            console.warn("Sync status polling timeout reached");
            updateDropboxSyncStatusWithType("Timeout", "", 90, "error");
            if (buttonElement) hideDropboxIconLoadingSpinner(buttonElement);
            autoHideDropboxSyncStatusWithType();
            return;
          }

          // Update progress based on attempts
          const progressPercent = Math.min(75 + attempts * 2, 95);
          updateDropboxSyncStatusWithType(`Syncing...`, "", progressPercent);

          // Continue polling
          setTimeout(poll, pollInterval);
          break;

        default:
          console.warn("Unknown sync status:", statusData.status);
          updateDropboxSyncStatusWithType("Unknown", "", 50, "error");
          if (buttonElement) hideDropboxIconLoadingSpinner(buttonElement);
          autoHideDropboxSyncStatusWithType();
          return;
      }
    } catch (error) {
      console.error("Error checking sync status:", error);

      if (attempts >= maxAttempts) {
        updateDropboxSyncStatusWithType("Connection Error", "", 0, "error");
        if (buttonElement) hideDropboxIconLoadingSpinner(buttonElement);
        autoHideDropboxSyncStatusWithType();
        return;
      }

      // Show retry message
      updateDropboxSyncStatusWithType("Retrying...", "", 75);

      // Retry on error
      setTimeout(poll, pollInterval);
    }
  };

  // Start polling
  poll();
}

// Functions to control the sync status display
function showDropboxSyncStatus(title = "Syncing...", message = "Preparing your file for sync", progress = 0) {
  const statusElement = document.getElementById("dropbox-sync-status");
  const titleElement = document.getElementById("sync-status-title-inline");
  const iconElement = document.querySelector(".sync-status-icon-inline");
  const buttonElement = document.getElementById("dropbox-sync-button");

  console.log("Showing sync status:", { title, progress });
  console.log("Elements found:", {
    statusElement: !!statusElement,
    titleElement: !!titleElement,
    iconElement: !!iconElement,
    buttonElement: !!buttonElement,
  });

  if (statusElement) {
    statusElement.style.display = "inline-flex";
    if (titleElement) titleElement.textContent = title;

    // Reset icon state
    if (iconElement) iconElement.className = "sync-status-icon-inline";

    // Disable button during sync
    if (buttonElement) buttonElement.classList.add("syncing");
  }
}

function updateDropboxSyncStatusWithType(title, message = "", progress = null, status = "in_progress") {
  const titleElement = document.getElementById("sync-status-title-inline");
  const iconElement = document.querySelector(".sync-status-icon-inline");

  console.log("Updating sync status:", { title, progress, status });
  console.log("Elements found:", {
    titleElement: !!titleElement,
    iconElement: !!iconElement,
  });

  if (titleElement) titleElement.textContent = title;

  // Update icon based on status
  if (iconElement) {
    iconElement.className = `sync-status-icon-inline ${status}`;
  }
}

function hideDropboxSyncStatus() {
  const statusElement = document.getElementById("dropbox-sync-status");
  const buttonElement = document.getElementById("dropbox-sync-button");

  if (statusElement) {
    statusElement.style.display = "none";
  }

  // Re-enable button
  if (buttonElement) {
    buttonElement.classList.remove("syncing");
  }
}

// Auto-hide status after success/error (optional)
function autoHideDropboxSyncStatusWithType(delay = 3000) {
  setTimeout(() => {
    hideDropboxSyncStatus();
  }, delay);
}

// Functions to show/hide the loading spinner in the dropbox icon product buttons
function showDropboxIconLoadingSpinner(buttonElement) {
  const iconElement = buttonElement.querySelector(".dropbox-icon");
  const spinnerElement = buttonElement.querySelector(".dropbox-loading-spinner");
  const checkmarkElement = buttonElement.querySelector(".dropbox-checkmark");

  if (buttonElement) {
    buttonElement.disabled = true;
    buttonElement.classList.add("syncing");
  }

  if (iconElement) {
    iconElement.style.display = "none";
  }

  if (checkmarkElement) {
    checkmarkElement.classList.add("hidden");
  }

  if (spinnerElement) {
    spinnerElement.classList.remove("hidden");
  }
}

function showDropboxIconCheckmark(buttonElement) {
  const iconElement = buttonElement.querySelector(".dropbox-icon");
  const spinnerElement = buttonElement.querySelector(".dropbox-loading-spinner");
  const checkmarkElement = buttonElement.querySelector(".dropbox-checkmark");

  if (iconElement) {
    iconElement.style.display = "none";
  }

  if (spinnerElement) {
    spinnerElement.classList.add("hidden");
  }

  if (checkmarkElement) {
    checkmarkElement.classList.remove("hidden");
  }
}

function hideDropboxIconLoadingSpinner(buttonElement) {
  const iconElement = buttonElement.querySelector(".dropbox-icon");
  const spinnerElement = buttonElement.querySelector(".dropbox-loading-spinner");
  const checkmarkElement = buttonElement.querySelector(".dropbox-checkmark");

  if (buttonElement) {
    buttonElement.disabled = false;
    buttonElement.classList.remove("syncing");
  }

  if (iconElement) {
    iconElement.style.display = "";
  }

  if (spinnerElement) {
    spinnerElement.classList.add("hidden");
  }

  if (checkmarkElement) {
    checkmarkElement.classList.add("hidden");
  }
}
